import React, { useEffect } from "react";

// Components
import NavbarAndSidebarLayout from "~/layouts/NavbarAndSidebarLayout";
import PageHeader from "~/common/components/PageHeader";

// Assets
import "~/assets/sass/pages/mypage/alarm/alarm.scss";
import useRequest from "~/common/hooks/useRequest";
import { API_STATE } from "~/common/constants/state";
import { useGlobalStore } from "~/store";
import { useTranslation } from "react-i18next";
import useRepository from "~/common/hooks/useRepository";
import { ALARM_LIST } from "~/store/alarm/repository";
import {TITLE_TOOLTIP} from "~/common/constants/tooltip";
import {QuestionMarkIcon} from "~/assets/svg/InterfaceIcon";


const AlarmPage = () => {

    const { t } = useTranslation();
    const [
        {
            alarm: { alarmList },
        },
    ] = useGlobalStore();

    const alarmReadRequest = useRequest("post", "vc/user/alarm");
    const alarmReadAllRequest = useRequest("patch", "vc/user/alarm/readAll");
    const [getAlarmList] = useRepository(ALARM_LIST);

    useEffect(() => {
        switch (alarmReadRequest.state) {
            case API_STATE.done:
                getAlarmList();
                break;
            default:
                break;
        }
    }, [alarmReadRequest.state, alarmReadRequest.response]);

    useEffect(() => {
        switch (alarmReadAllRequest.state) {
            case API_STATE.done:
                getAlarmList();
                break;
            default:
                break;
        }
    }, [alarmReadAllRequest.state, alarmReadAllRequest.response]);

    const clickRead = (read, idx) => {
        if (read) return;
        alarmReadRequest.call(idx, "path");
    };

    const clickReadAll = () => {
        alarmReadAllRequest.call();
    };

    const headerButtons = [
        <button type="button" className="btn__solid" color="primary" onClick={clickReadAll}>
            {t("pages.myPage.AlarmPage.alarm-readAll")}
        </button>,
    ];

    return(
        <NavbarAndSidebarLayout menu={["alarm", "list"]} type="main">
            <div className="l__pageHeader">
                <h2 className="page-name">전체 알림</h2>
                <ol className="c__breadcrumb">
                    <li>Home</li>
                    <li>알람</li>
                    <li>전체알람</li>
                </ol>
                <div className="divider" />
            </div>
            <div className="pageHeader-btn-group">
                <button type="button" className="btn__solid" color="primary" onClick={clickReadAll}>
                    {t("pages.myPage.AlarmPage.alarm-readAll")}
                </button>
            </div>

            <div className="c__card">
                <div className="alarm-table">
                    <div className="alarm-thead">
                        <div className="alarm-number">No</div>
                        <div className="alarm-type">{t("pages.myPage.AlarmPage.alarm-type")}</div>
                        <div className="alarm-content">
                            {t("pages.myPage.AlarmPage.alarm-content")}
                        </div>
                        <div className="alarm-date">{t("pages.myPage.AlarmPage.alarm-date")}</div>
                        <div className="alarm-status">
                            {t("pages.myPage.AlarmPage.alarm-status")}
                        </div>
                    </div>
                    <div className="alarm-tbody">
                        {alarmList.length > 0 ? (
                            alarmList.map((item, index) => (
                                <div key={item.idx} className="alarm-tr">
                                    <div className="alarm-number">{index + 1}</div>
                                    <div className="alarm-type">
                                        <span className="online-exam">{item.type}</span>
                                    </div>
                                    <div className="alarm-content">{item.title}</div>
                                    <div className="alarm-date">{item.regDate}</div>
                                    <div className="alarm-status">
										<span
                                            className={`custom-badge ${
                                                item.read ? "alarm-read" : ""
                                            }`}
                                            onClick={() => clickRead(item.read, item.idx)}
                                        >
											{item.read
                                                ? t("pages.myPage.AlarmPage.alarm-read")
                                                : t("pages.myPage.AlarmPage.alarm-unread")}
										</span>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="alarm-tr">
                                <div className="alarm-content">
                                    {t("pages.myPage.AlarmPage.alarmNoContent")}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </NavbarAndSidebarLayout>
    )
}

export default AlarmPage
